import { render, staticRenderFns } from "./ListPaymentsCustomer.vue?vue&type=template&id=53ea9d39&scoped=true&lang=pug&"
import script from "./ListPaymentsCustomer.vue?vue&type=script&lang=ts&"
export * from "./ListPaymentsCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ListPaymentsCustomer.vue?vue&type=style&index=0&id=53ea9d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea9d39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VIcon,VProgressLinear,VRow,VSheet,VSimpleTable,VTooltip})
